import axios from "axios";
import { AnswerFileResult } from "../../../store/viewmodels/AnswerFileViewModel";
import { useAppSelector } from "../../../store/Hooks";
import { Student, StudentData } from "../../../store/viewmodels/StudentViewModel";
import { AnswerResult } from "../../../store/viewmodels/AnswerViewModel";
import { Itemset } from "../../../store/viewmodels/ItemsetViewModel";

interface StudentVideoRecordingResultProps {
    answers: AnswerResult[],
    itemset: Itemset,
    showModal: () => void,
    setAnswerToWatch: React.Dispatch<React.SetStateAction<AnswerFileResult | undefined>>,
}

function StudentVideoRecordingResult(props: StudentVideoRecordingResultProps): JSX.Element {
    const studentData: StudentData = useAppSelector(state => state.studentData)
    const answerFiles: AnswerFileResult[] = studentData.student.answer_files!

    let videoAnswers = [];

    for (let i: number = 0; i < answerFiles.length; i++) {

        let fileItemsetId = answerFiles[i].itemset;

        if (!fileItemsetId) {
            let answerFile: AnswerFileResult | null = searchItemSetByFileName(answerFiles[i], props.itemset);
            if (answerFile !== null) {
                videoAnswers.push(answerFile);
            }
        } else if (fileItemsetId === props.itemset.id) {
            videoAnswers.push(answerFiles[i]);
        }
    }

    const downloadFile = (id: number, filename: string) => {
        const URL: string = window.location.href.includes('localhost') ? 'http://localhost:8000/api/answerfiles/' + id + '/get_video/' : '/api/answerfiles/' + id + '/get_video/'
        axios({
            url: URL,
            method: 'GET',
            responseType: 'blob',
        }).then((response) => {
            const blob = new Blob([response.data]);
            const videoURL = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = videoURL;
            link.setAttribute('download', filename + '.mp4');
            document.body.appendChild(link);
            link.click();
        });
    }

    const showVideo = (answerFile: AnswerFileResult) => {
        props.setAnswerToWatch(answerFile);
        props.showModal();
    }

    if (props.answers.length === 0 || answerFiles.length === 0) return <></>;
    let videos = [];

    for (let i = 0; i < videoAnswers.length; i++) {
        let answerFile = videoAnswers[i];
        let filePath = decodeURI(videoAnswers[i].file);
        let fileInfo = getFileInfo(filePath, studentData.student)
        const fileInfos: string[] = filePath.split('_')
        const endDate: Date = answerFile.itemset ? new Date(answerFile.submit_time) : getEndTimeByFileName(fileInfo, props.itemset);
        const endTime = endDate.getDate() + "." + (endDate.getMonth() + 1) + "." + endDate.getFullYear();
        const endClockTime = " klo " + endDate.getUTCHours() + ":" + endDate.getMinutes();
        const itemName = getItemNameByFileName(filePath, props.itemset);

        videos.push(
            <div key={"videoRecordingResult_border" + answerFile.id} className="m-2 p-2 border border-teal-200">
                <div className="text-center m-auto">
                    <label className="text-xs">{itemName}</label>
                </div>
                <div className="flex">
                    <button className="text-center m-auto block" type="button" onClick={() => downloadFile(answerFile.id!, fileInfos[3])}>
                        <span className="ri-file-download-line text-8xl text-teal-500 hover:text-teal-400"></span>
                    </button>
                    <button className="text-center m-auto block" type="button" onClick={() => showVideo(answerFile)}>
                        <span className="ri-movie-line text-8xl text-teal-500 hover:text-teal-400"></span>
                    </button>
                </div>
                <div className="text-center m-auto">
                    <label className="text-xs">{endTime + endClockTime}</label>
                </div>
            </div>
        )
    }

    return (
        <div>
            <h1 className="m-auto text-center text-2xl text-teal-500 font-bold">Videotallenteet</h1>
            <div className="border border-teal-200 my-2 p-2 flex flex-wrap">
                {videos}
            </div>
        </div>
    );
}

function getItemNameByFileName(filePath: string, itemset: Itemset): string {

    for (let i: number = 0; i < itemset.items.length; i++) {
        let modFilePath = filePath.replaceAll(/[^a-zA-Z0-9]/g, '');

        let item_name = itemset.items[i].name;
        item_name = item_name.replaceAll(/[^a-zA-Z0-9]/g, '');

        if (modFilePath.includes(item_name)) {
            return itemset.items[i].name;
        }
    }

    return "";
}

function getFileInfo(filePath: string, student: Student): string {

    let splittedPath = filePath.split('/');
    let fileInfo = splittedPath[splittedPath.length - 1];
    fileInfo = fileInfo.replace(student.username, ''); //removes student username from the string
    fileInfo = fileInfo.replace(".mp4", ''); //removes .mp4 from the string

    return fileInfo;
}

function getEndTimeByFileName(fileInfo: string, itemset: Itemset): Date {
    let itemset_name = itemset.name.replaceAll(' ', '_');
    let cleanedInfo = fileInfo.replace(itemset_name, ''); //removes itemset name from the string

    let splittedInfo = cleanedInfo.split('_');

    for (let i: number = 0; i < splittedInfo.length; i++) {
        if (splittedInfo[i] === "") {
            splittedInfo.splice(i, 1);
            i--
        }
    }

    let timeIndexStart = splittedInfo.length - 5; //last five are time stamp
    let timeInfo = splittedInfo.slice(timeIndexStart, splittedInfo.length);

    let day = parseInt(timeInfo[0]);
    let month = parseInt(timeInfo[1]) - 1;
    let year = parseInt(timeInfo[2]);
    let hours = parseInt(timeInfo[3]);
    let minutes = parseInt(timeInfo[4]);

    return new Date(year, month, day, hours, minutes);
}

function searchItemSetByFileName(file: AnswerFileResult, itemset: Itemset) {
    let filePath = decodeURI(file.file);
    filePath = filePath.replaceAll(/[^a-zA-Z0-9]/g, '');

    let itemsetName = decodeURI(itemset.name);
    itemsetName = itemsetName.replaceAll(/[^a-zA-Z0-9]/g, '');

    if (filePath.includes(itemsetName)) {
        return file;
    }
    return null;
}

export default StudentVideoRecordingResult;